import {AuthService} from "./AuthService";

// Admin-only Campaign Quality scoring API client. Delegates to the shared
// AuthService axios layer (auth header injected per-request); never imports
// axios directly. Mirrors BotGroupService / CampaignService conventions.
export class CampaignQualityService {

    url = `admin/campaign_quality/`;

    // GET admin/campaign_quality with optional filters
    // (account_type, usage_type, grade, q, sort). Returns the results array.
    list(params = {}) {
        return AuthService.apiGet(this.url, {params: params}).then(res => res.data.results);
    }

    // GET admin/campaign_quality/<campaign_id>. Returns the full detail payload
    // (latest snapshot fields + trend array).
    detail(campaignId) {
        return AuthService.apiGet(this.url + campaignId + "/").then(res => res.data);
    }

    // POST admin/campaign_quality/<campaign_id>/recompute. Recomputes and saves
    // a fresh snapshot, returning the new snapshot payload.
    recompute(campaignId) {
        return AuthService.apiPost(this.url + campaignId + "/recompute/").then(res => res.data);
    }

    // POST admin/campaign_quality/bulk_recompute. Enqueues an async bulk
    // recompute job. Pass an empty array to recompute ALL eligible campaigns.
    bulkRecompute(campaignIds = []) {
        return AuthService.apiPost(this.url + "bulk_recompute/", {campaign_ids: campaignIds}).then(res => res.data);
    }

    // GET admin/campaign_quality/campaigns?user_id=<id>. Returns the customer's
    // non-demo campaigns (including unscored); overall/grade/computed_at are null
    // when has_score is false.
    campaignsForUser(userId) {
        return AuthService.apiGet(this.url + "campaigns/", {params: {user_id: userId}}).then(res => res.data.results);
    }

    // GET admin/campaign_quality/campaigns?user_ids=<id1,id2,...>. Returns the
    // union of all specified customers' non-demo campaigns (including unscored).
    campaignsForUsers(userIds = []) {
        return AuthService.apiGet(this.url + "campaigns/", {params: {user_ids: userIds.join(",")}}).then(res => res.data.results);
    }

    // GET admin/campaign_quality/customers. Returns only users with an active
    // subscription (paid or trial) eligible for quality scoring.
    customers() {
        return AuthService.apiGet(this.url + "customers/").then(res => res.data.results);
    }
}
